// extracted by mini-css-extract-plugin
export default {"searchResultDescription":"style__searchResultDescription___2HkD5","fadeFront":"style__fadeFront___1vWRi"};